module.exports = __webpack_public_path__ + "static/media/IMG_4281.7e393336.PNG";